import { useMemo } from 'react';
import { LayoutType } from 'signup-components/types';
import Separator from '../step-landing-page/Separator';
import { SidePanelSeparator } from '../step-landing-page/side-panel/SidePanelSeparator';
import { Step } from 'signup-constants/Step';
import { OAuthProviders } from './OAuthProviders';
import { OAuthVerificationFailureText } from './OAuthVerificationFailureText';
import { useOAuthSignup } from './useOAuthSignup';
import { AppleButton } from '../apple/AppleButton';
import { GoogleOAuthButton } from '../google-authentication/GoogleOAuthButton';
import { MicrosoftButton } from '../microsoft/MicrosoftButton';
import { View } from 'foundations-components/components/View';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { useIsSU0004Variation } from '../hooks/useIsSU0004Variation';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getOAuthComponents = isSU0004Variation => ({
  [OAuthProviders.Microsoft]: /*#__PURE__*/_jsx(MicrosoftButton, {
    textOverride: isSU0004Variation ? `views.${Step.LandingPage}.SU0004.continueWithMicrosoft` : undefined
  }),
  [OAuthProviders.Google]: /*#__PURE__*/_jsx(GoogleOAuthButton, {}),
  [OAuthProviders.Apple]: /*#__PURE__*/_jsx(AppleButton, {
    textOverride: isSU0004Variation ? `views.${Step.LandingPage}.SU0004.continueWithApple` : undefined
  })
});
export const OAuthSignupSection = ({
  shouldShowSeperator = true
}) => {
  const {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  } = useOAuthSignup();
  const {
    layoutType
  } = useLayoutTemplate();
  const isSU0004Variation = useIsSU0004Variation();
  const isSidePanel = layoutType === LayoutType.SidePanel;
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const oAuthComponents = useMemo(() => getOAuthComponents(isSU0004Variation), [isSU0004Variation]);
  const renderOAuths = () => {
    return Object.keys(oAuthsEnabledByFlowConfig).filter(oAuth => oAuthsEnabledByFlowConfig[oAuth]).map(oAuth => {
      return /*#__PURE__*/_jsxs("div", {
        children: [oAuthComponents[oAuth], /*#__PURE__*/_jsx(OAuthVerificationFailureText, {
          oAuth: oAuth
        })]
      }, oAuth);
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    marginBlockStart: isSidePanel ? '0' : '400',
    children: [renderOAuths(), atLeastOneOAuthEnabled && shouldShowSeperator && !isSidePanel && !isTrellisThemeEnabled && /*#__PURE__*/_jsx(Separator, {
      message: `views.${Step.LandingPage}.separator`
    }), atLeastOneOAuthEnabled && shouldShowSeperator && isSidePanel && /*#__PURE__*/_jsx(SidePanelSeparator, {
      message: `views.${Step.LandingPage}.separator`
    }), atLeastOneOAuthEnabled && shouldShowSeperator && !isSidePanel && isTrellisThemeEnabled && /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: "420px",
      paddingInline: "400",
      children: /*#__PURE__*/_jsx(SidePanelSeparator, {
        message: `views.${Step.LandingPage}.separator`
      })
    })]
  });
};